import { dpprApiGet } from 'utils/http'
import httpExceptionUtil from 'utils/httpExceptionUtil'

const SEARCH_PREFIX = '/public'

export const fetchSearchConfig = async (integratorShortName, countryCode) => {
  try {
    return await dpprApiGet({ url: `${SEARCH_PREFIX}/config/${integratorShortName}/${countryCode}` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}
